import { capitalizeFirstLetter } from './otherHelpers';

export const convertUrl = (url: string) => {
  return url
    .split('-')
    .map((word) => capitalizeFirstLetter(word))
    .join(' ');
};
